import { sendGet, sendPost } from 'api/axios';
import { LANGUAGE, CustomerLocationType, CustomerAccountType, VendorCode, CountryCode, ACTIVE, InvoiceStatus } from 'common';
import { handleErrorMessage } from 'helper';
import numeral from 'numeral';
import _ from 'lodash';
import moment from 'moment';
import i18n from 'i18next';
export function getBase64(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
}

export function convertPriceJP(price: any, currentCyRate: any) {
  price = price || 0;
  const moneyJP = new Intl.NumberFormat('jp-JP', {
    style: 'currency',
    currency: 'JPY',
  }).format(price);
  const convertPriceJPToUSD = Number(price) / Number(currentCyRate);
  const moneyUSD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(convertPriceJPToUSD);
  const renderPrice: any = {
    [LANGUAGE.JA]: moneyJP,
    [LANGUAGE.EN]: moneyUSD,
  };
  return renderPrice[i18n?.language];
}
export function defaultValueDate(startDate: any, endDate: any) {
  const dateFormat = 'YYYY/MM/DD';
  if (startDate && endDate) {
    return [moment(startDate, dateFormat), moment(endDate, dateFormat)];
  }
  return ['', ''];
}
export function getVolume(length: number, width: number, height: number) {
  let result = (width * length * height) / 5000;
  if (!result) return;
  result = Math.round(result * 1000);
  return result;
}
export function calcPackagesVolume(packages: any) {
  let volume = 0
  for (const pkg of packages) {
    if (pkg) volume += getVolume(pkg['length'], pkg.width, pkg.height) || 0
  }
  return volume
}

export function convertPrice(dataItem: any, accountType: number, locationType: number, currentCyRate: any) {
  let price = 0;
  if (locationType == CustomerLocationType.DOMESTIC) {
    price =
      accountType === CustomerAccountType.PERSONAL ? dataItem.personalDomesticPrice : dataItem.businessDomesticPrice;
    price = Number(price);
    const money = new Intl.NumberFormat('jp-JP', {
      style: 'currency',
      currency: 'JPY',
    }).format(price);
    return money;
  }
  if (locationType == CustomerLocationType.FOREIGN) {
    price =
      accountType === CustomerAccountType.PERSONAL ? dataItem.personalForeignPrice : dataItem.businessForeignPrice;
    price = Number(price);
    currentCyRate = Number(currentCyRate);
    const result = price / currentCyRate;
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(result);
    return money;
  }
}
export function convertPriceJPToUSD(price: number, currentCyRate: any) {
  price = price || 0;
  const convertPriceJPToUSD = Number(price) / Number(currentCyRate);
  return convertPriceJPToUSD;
}

export function renderPriceOptionService(dataItem: any, accountType: number, locationType: number) {
  let price = 0;
  if (locationType == CustomerLocationType.DOMESTIC) {
    price =
      accountType === CustomerAccountType.PERSONAL ? dataItem.personalDomesticPrice : dataItem.businessDomesticPrice;
  }
  if (locationType == CustomerLocationType.FOREIGN) {
    price =
      accountType === CustomerAccountType.PERSONAL ? dataItem.personalForeignPrice : dataItem.businessForeignPrice;
  }
  return price;
}
export function getNameServiceDelivery(listData: any, code: any) {
  const result = listData.find((x: any) => x?.code === code);
  return result?.name || '';
}
export const cutText = (str: any, length?: number) => {
  const strLength = length || 10;
  if ((str && str.length <= strLength) || str.length - strLength <= 10) {
    return str;
  } else {
    const arrayString = str?.split('@');
    const nameFile = _.head(arrayString) as string;
    const lastNameFile = nameFile?.substring(nameFile?.length - 10);

    const newStr = `${nameFile.substring(0, strLength)}...@${_.last(arrayString)}`;
    return newStr;
  }
};
export const getDataResourceByKey = (resource: any, key: string, id: string) => {
  if (!resource) return;
  const value = resource?.[key]?.find((x: any) => x.id == id);
  return value?.name;
};
export const getCodeResourceByKey = (resource: any, key: string, id: string) => {
  if (!resource) return;
  const value = resource?.[key]?.find((x: any) => x.id == id);
  return value?.code;
};

export const formulaCalculation = (dataMass: any, code: any) => {
  let { length, width, height, weight } = dataMass;
  weight = Number(weight);
  length = Number(length);
  width = Number(width);
  height = Number(height);
  if (code === VendorCode.FEDEX) {
    const maxWeight = Math.floor(68038.9);
    const maxLenght = 274; //cm
    const maxLenghtWidthHeight = 330; //cm
    const totalFormula = length + 2 * width + height * 2;
    if (weight > maxWeight || totalFormula > maxLenghtWidthHeight || length > maxLenght) {
      return false;
    }
    return true;
  }
  if (code === VendorCode.FEDEX_ECONOMY) {
    const maxWeight = Math.floor(68038.9);
    const maxLenght = 274; //cm
    const maxLenghtWidthHeight = 330; //cm
    const totalFormula = length + 2 * width + height * 2;
    if (weight > maxWeight || totalFormula > maxLenghtWidthHeight || length > maxLenght) {
      return false;
    }
    return true;
  }
  if (code === VendorCode.FEDEX_CONNECT_PLUS) {
    const maxWeight = Math.floor(68038.9);
    const maxLenght = 274; //cm
    const maxLenghtWidthHeight = 330; //cm
    const totalFormula = length + 2 * width + height * 2;
    if (weight > maxWeight || totalFormula > maxLenghtWidthHeight || length > maxLenght) {
      return false;
    }
    return true;
  }
  if (code === VendorCode.DHL) {
    const maxWeight = 70000; //g
    const maxLenght = 120; //cm
    const maxWidth = 80; //cm
    const maxHeight = 80; //cm
    if (weight > maxWeight || length > maxLenght || width > maxWidth || height > maxHeight) {
      return false;
    }
    return true;
  }
  if (code === VendorCode.Dmail) {
    const maxWeight = 2000; //g
    const maxLenght = 60; //cm
    const maxLenghtWidthHeight = 90; //cm
    const totalLengthWidthHeight = length + width + height;
    if (totalLengthWidthHeight > maxLenghtWidthHeight || length > maxLenght || weight > maxWeight) {
      return false;
    }
    return true;
  }
};
export const getPriceVendor = async (dataMass: any, code: any) => {
  for (const [i, v] of dataMass.packages.entries()) {
    dataMass.packages[i] = {
      weight: numeral(dataMass?.packages[i]?.weight).value(),
      length: Number(dataMass?.packages[i]?.length),
      width: Number(dataMass?.packages[i]?.width),
      height: Number(dataMass?.packages[i]?.height),
      declaredValueClient: numeral(dataMass?.packages[i]?.declaredValueClient).value()
    }
  }
  const params = {
    packages: dataMass.packages,
    orderDetail: dataMass?.orderDetail?.map((item: any) => ({
      ...item,
      countryId: Number(item?.countryId),
      quantity: Number(item?.quantity),
      unitPrice: numeral(item?.unitPrice).value(),
      weight: item?.weight == null ? null : numeral(item?.weight).value(),
    })),
    orderSenderAddress: {
      address1: dataMass?.orderSenderAddress?.address1,
      address2: dataMass?.orderSenderAddress?.address2,
      countryId: dataMass?.orderSenderAddress?.countryId,
      province: dataMass?.orderSenderAddress?.province,
      zipCode: dataMass?.orderSenderAddress?.zipCode,
      // stateCode: dataMass?.orderSenderAddress?.stateCode,
    },
    orderReceiveAddress: {
      address1: dataMass?.orderReceiveAddress?.address1,
      address2: dataMass?.orderReceiveAddress?.address2,
      countryId: dataMass?.orderReceiveAddress?.countryId,
      province: dataMass?.orderReceiveAddress?.province,
      zipCode: dataMass?.orderReceiveAddress?.zipCode,
      stateCode: dataMass?.orderReceiveAddress?.stateCode,
    },
    classification: dataMass?.classification,
    declaredValueClient: dataMass?.declaredValueClient,
    isUseInsurance: dataMass?.isUseInsurance || ACTIVE.FALSE,
  };
  try {
    let dataPrice;
    if (code === VendorCode.FEDEX) {
      dataPrice = await sendPost('/vendors/quotation-fedex', params);
    }
    if (code === VendorCode.FEDEX_ECONOMY) {
      dataPrice = await sendPost('/vendors/quotation-fedex-economy', params);
    }
    if (code === VendorCode.FEDEX_CONNECT_PLUS) {
      dataPrice = await sendPost('/vendors/quotation-fedex-connect-plus', params);
    }
    if (code === VendorCode.DHL) {
      dataPrice = await sendPost('/vendors/quotation-dhl', params);
    }
    if (code === VendorCode.Dmail) {
      dataPrice = await sendPost('/vendors/quotation-dmail', params);
    }

    if (dataPrice.data.status == 'failed') {
      throw { display: true, message: dataPrice.data.message }
    }

    const { processingFee, fee, accountIndex } = dataPrice?.data;
    return { fee: fee ? processingFee + fee : fee, accountIndex }
  } catch (error) {
    handleErrorMessage(error);
  }
};
export const getPriceVendorDetail = async (idOrder: number, code: any) => {
  try {
    let dataPrice;
    if (code === VendorCode.FEDEX) {
      dataPrice = await sendGet(`/vendors/quotation-fedex/${idOrder}`);
    }
    if (code === VendorCode.DHL) {
      dataPrice = await sendGet(`/vendors/quotation-dhl/${idOrder}`);
    }
    if (code === VendorCode.Dmail) {
      dataPrice = await sendGet(`/vendors/quotation-dmail/${idOrder}`);
    }

    if (dataPrice.data.status == 'failed') {
      throw { display: true, message: dataPrice.data.message }
    }

    const { processingFee, fee } = dataPrice?.data;
    return fee ? processingFee + fee : fee;
  } catch (error) {
    handleErrorMessage(error);
  }
};
export function renderPrice(totalAmount: any, systemTax: any, currencyRate: any) {
  const total = (Number(totalAmount) * Number(systemTax)) / 100;
  const result = convertPriceJP(total, currencyRate);
  return result;
}
export function renderTotalPriceTax(totalAmount: any, systemTax: any, currencyRate: any) {
  const total = (Number(totalAmount) * Number(systemTax)) / 100;
  let result = Number(totalAmount) + Number(total);
  result = convertPriceJP(result, currencyRate);
  return result;
}
export function convertAddressAndCountry(address: any, resource: any) {
  const country = resource?.data?.countries?.find((x: any) => x?.id === address?.countryId);
  const result = convertAddress({ ...address, country });
  return result;
}
export function convertAddress(address: any) {
  const { zipCode, stateCode, province, address1, address2, warehouseBlockCode, country } = address;
  let result;
  if (country.code === CountryCode.JAPAN) {
    result =
      `〒${zipCode}${stateCode ? ` ${stateCode}` : ''}, ${province}, ${address1}` +
      (!!address2 ? `, ${address2}` : '') +
      `${country.name ? `, ${country.name}` : ``}` +
      `${warehouseBlockCode ? ` - ${warehouseBlockCode}` : ``}`;
  }
  if (country.code !== CountryCode.JAPAN) {
    result = `${!!address2 ? ` ${address2}` : ''} ${address1}, ${province}, ${
      stateCode ? ` ${stateCode} ` : ''
    }${zipCode}${country.name ? `, ${country.name}` : ``} ${warehouseBlockCode ? ` - ${warehouseBlockCode}` : ``}`;
  }
  return result;
}

export function getFullNameByLocation(profile: any) {
  return profile?.locationType === CustomerLocationType.DOMESTIC
    ? profile?.fullNameJp || profile?.fullName
    : profile?.fullName || profile?.fullNameJp;
}

export function redirectToTrackingPage(vendorCode: VendorCode, trackingNumber: number) {
  if (!vendorCode || !trackingNumber) return;
  let dhlTracking = 'https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=' + trackingNumber;
  let fedexTracking = `https://www.fedex.com/fedextrack/?action=track&tracknumbers=${trackingNumber}&locale=en_US&cntry_code=us`;
  if (i18n?.language === LANGUAGE.JA) {
    dhlTracking = dhlTracking.replace('us-en', 'jp-ja');
    fedexTracking = fedexTracking.replace('en_US', 'ja_JP');
  }
  const urlTracking = vendorCode === VendorCode.DHL ? dhlTracking : fedexTracking;
  window.open(urlTracking, '_blank');
}

export function calculatePaymentTransferTax(price = 0) {
  return price * 10 / 100;
};

export function totalPriceAfterTax(listCurrency: string[]) {
  const totalPriceAfterTax = listCurrency?.reduce(
    (total, currentItem) => total + Number(currentItem.slice(1, currentItem.length)?.replaceAll(',', '')),
    0
  );
  if (i18n?.language === LANGUAGE.JA) {
    return new Intl.NumberFormat('jp-JP', {
      style: 'currency',
      currency: 'JPY',
    }).format(totalPriceAfterTax);
  }
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totalPriceAfterTax);
};
